module.exports = __webpack_public_path__ + "static/index/img/baikal-609.430258ad.jpg";